

exports.__esModule = true;

var _uiRouter = require('uiRouter');

var _squid = require('squid');

var _angular = require('angular');

var _logger = require('xo-beaver/dist/logger');

var _index = require('xo-models/src/app/index');

require('xo-ui-components/src/mobile-pin/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoPinSetupPageDirective', {
    tag: 'xo-pin-setup',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            _logger.$logger.info('tokenized_wallet', {
                'from': 'PINSETUP',
                'to': 'PREPARE_PINSETUP'
            });
        }
    },
    controller: ['$scope', function ($scope) {
        var currentPin = '';

        $scope.madeAttempt = false;
        $scope.pinError = '';
        $scope.pinChanged = false;

        function done(pinValue) {
            _index.$TokenizedWalletPinModel.instance(_angular.$rootScope.token).retrieve().then(function (WalletPinModel) {
                WalletPinModel.userPin = pinValue;
                _logger.$logger.info('tokenized_wallet', {
                    'from': 'PINSETUP',
                    'to': 'PROCESS_PINSETUP'
                });
                (0, _angular.$timeout)(function () {
                    return _uiRouter.$state.go('checkout.review');
                }, 1500);
            });
        }

        $scope.pinComplete = function (result) {
            var value = result && result.value;

            if (result && result.error === 'pin_too_simple') {
                $scope.pinError = 'toEasy';
                $scope.madeAttempt = false;
                currentPin = '';
                $scope.$broadcast('resetPin');
                return;
            }

            $scope.pinChanged = $scope.madeAttempt && currentPin === value;
            $scope.pinError = $scope.madeAttempt && !$scope.pinChanged ? 'missMatch' : '';
            currentPin = $scope.madeAttempt ? '' : value; // reset old pin if already made an attempt
            $scope.madeAttempt = !$scope.madeAttempt; // flip flag

            if (!$scope.pinChanged) {
                $scope.$broadcast('resetPin');
            } else {
                done(value);
            }
        };
    }]
});


_uiRouter.$state;

_squid.$Component;

_angular.$rootScope;

_angular.$timeout;

_logger.$logger;

_index.$TokenizedWalletPinModel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-pin-setup/directive.js
// module id = ./pages/xo-pin-setup/directive.js
// module chunks = 0